import React, { useEffect, useState } from 'react';

import moment from 'moment-timezone';
import update from 'immutability-helper';

import Appearance from 'styles/Appearance.js';
import TextField from 'views/TextField.js';
import Utils from 'files/Utils.js';
import Views from 'views/Main.js';

const MultipleTextField = props => {

    const { loading, max, onChange, onRenderItem, useIdentifiers, value } = props;

    const [items, setItems] = useState([]);
    const [text, setText] = useState(null);

    const onAddItem = () => {
        let next = update(items, {
            $push: useIdentifiers !== true ? [text] : [{
                id: `${moment().unix()}-${Utils.randomString(5)}`,
                title: text
            }]
        });
        setText(null);
        setItems(next);
        if(typeof(onChange) === 'function') {
            onChange(next);
        }
    }

    const onRemoveItem = (index, evt) => {
        evt.stopPropagation();
        let next = update(items, { $splice: [[ index, 1 ]] });
        setItems(next);
        if(typeof(onChange) === 'function') {
            onChange(next);
        }
    }

    const getAppendContent = () => {

        // no icon is needed if text has not been provided
        if(!text || text.length === 0) {
            return null;
        }

        // no icon is needed if the optional max value has been reached
        if(max && max === items.length) {
            return null;
        }
        
        return (
            <div style={{
                flex: 'none',
                height: 20,
                marginLeft: 8,
                width: 20
            }}>
                <img
                className={'text-button'}
                src={'images/next-arrow-icon-green.png'}
                onClick={onAddItem}
                style={{
                    height: '100%',
                    objectFit: 'contain',
                    width: '100%'
                }} />
            </div>
        )
    }

    useEffect(() => {
        if(useIdentifiers !== true) {
            setItems(Array.isArray(value) ? value : []);
            return;
        }
        let values = value && Array.isArray(value) && value.map(val => {
            if(typeof(val) === 'object') {
                return val;
            }
            return {
                id: `${moment().unix()}-${Utils.randomString(5)}`,
                title: val
            }
        });
        setItems(values || []);
    }, [value]);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        }}>
            <TextField
            {...props}
            appendContent={getAppendContent()}
            loading={loading}
            onChange={setText}
            value={text} />
            {items.length > 0 && (
                <div style={{
                    ...Appearance.styles.unstyledPanel(),
                    borderRadius: 8,
                    marginTop: 8
                }}>
                    {items.map((item, index) => {
                        if(typeof(onRenderItem) === 'function') {
                            return (
                                <div key={index}>
                                    {onRenderItem(item, index, items, { onRemoveItem })}
                                </div>
                            );
                        }
                        return (
                            <div key={index}>
                                {Views.row({
                                    bottomBorder: index !== items.length - 1,
                                    hideOnClickArrow: true,
                                    label: typeof(item) === 'string' ? item : item.title,
                                    value: (
                                        <img
                                        className={'text-button'}
                                        onClick={onRemoveItem.bind(this, index)}
                                        src={'images/delete-red-icon.png'}
                                        style={{
                                            height: 20,
                                            objectFit: 'contain',
                                            width: 20
                                        }} />
                                    )
                                })}
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

export default MultipleTextField;
